<template>
  <div class="contract-management">
    <page-title title="筛选">
      <el-row class="contract-management__filter-header" :gutter="20">
        <el-col :xl="4" :span="6">
          <span>创作者/机构名称：</span>
          <el-input
            szie="small"
            v-model="filter.enterpriseName"
            placeholder="请输入"
          ></el-input>
        </el-col>
        <el-col :xl="4" :span="6">
          <span>注册手机号：</span>
          <el-input
            v-model="filter.phone"
            szie="small"
            placeholder="请输入"
          ></el-input>
        </el-col>
        <el-col :xl="4" :span="6">
          <span>类型：</span>
          <el-select
            v-model="filter.identityType"
            szie="small"
            placeholder="请选择"
          >
            <el-option label="文博机构" value="4"></el-option>
            <el-option label="创作主体" value="2"></el-option>
          </el-select>
        </el-col>
        <el-col :xl="4" :span="6">
          <span>审核状态：</span>
          <el-select v-model="filter.status" szie="small" placeholder="请选择">
            <el-option label="待审核" value="1"></el-option>
            <el-option label="已通过" value="2"></el-option>
            <el-option label="已拒绝" value="3"></el-option>
            <el-option label="已禁用" value="4"></el-option>
          </el-select>
        </el-col>
        <el-col :xl="3" :span="6">
          <el-button @click="search">查询</el-button>
          <el-button @click="reset">重置</el-button>
        </el-col>
      </el-row>
    </page-title>
    <page-title title="数据列表">
      <div class="contract-management__body">
        <el-table
          v-loading="loading"
          :data="tableData"
          style="width: 100%"
          :header-cell-style="{ backgroundColor: `#f7f7f7` }"
        >
          <el-table-column
            type="index"
            label="序号"
            width="100"
          ></el-table-column>
          <el-table-column prop="id" label="ID"></el-table-column>
          <el-table-column prop="enterpriseName" label="创作者/机构名称">
            <template slot-scope="scope">
              <span v-if="scope.row.identityAuthType == '1'">
                {{ scope.row.realName }}
              </span>
              <span v-else>
                {{ scope.row.enterpriseName }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="phone" label="注册手机号"></el-table-column>
          <el-table-column prop="identityType" label="类型">
            <template slot-scope="scope">
              {{ scope.row.identityType == "4" ? "文博机构" : "创作主体" }}
            </template>
          </el-table-column>
          <el-table-column prop="identityAuthType" label="认证类型">
            <template slot-scope="scope">
              {{
                scope.row.identityAuthType == "1"
                  ? "个人"
                  : scope.row.identityAuthType == "2"
                  ? "企业"
                  : "事业单位"
              }}
            </template>
          </el-table-column>
          <el-table-column prop="status" label="审核状态">
            <template slot-scope="scope">
              <el-tag :type="getStatusTagType(scope.row.status)">
                {{ getStatusText(scope.row.status) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="申请时间"></el-table-column>
          <el-table-column label="操作" width="300">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.status == '1'"
                type="text"
                @click="handleAudit(scope.row)"
                >审核</el-button
              >
              <el-button type="text" @click="handleDetail(scope.row)"
                >详情</el-button
              >
              <el-button
                v-if="scope.row.status == '2' || scope.row.status == '6'"
                type="text"
                @click="handleDisable(scope.row)"
                >禁用</el-button
              >
              <el-button
                v-if="scope.row.status == '4'"
                type="text"
                @click="handleEnable(scope.row)"
                >解禁</el-button
              >
              <el-button
                type="text"
                @click="handleUploadMaterial(scope.row)"
                v-if="
                  (scope.row.status == '2' || scope.row.status == '6') &&
                    scope.row.identityType == '4'
                "
                >资源代传</el-button
              >
              <el-button
                type="text"
                v-if="scope.row.signStatus == '4'"
                @click="handleDownloadContract(scope.row)"
                >下载合同</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <cus-pagination
          :total="total"
          :current-page.sync="currentPage"
          :page-size.sync="pageSize"
          @size-change="getList"
        ></cus-pagination>
      </div>
    </page-title>

    <!-- 审核/禁用/解禁弹窗 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="600px"
      append-to-body
    >
      <el-form
        :model="dialogForm"
        label-width="140px"
        ref="dialogForm"
        :rules="rules"
      >
        <el-form-item
          :label="labelText + '：'"
          prop="reason"
          v-if="operationType !== 'detail'"
        >
          <el-input
            maxlength="200"
            show-word-limit
            v-model.trim="dialogForm.reason"
            type="textarea"
            :rows="3"
            :placeholder="labelText"
          ></el-input>
        </el-form-item>
        <el-form-item label="" v-if="operationType === 'detail'">
          <div>
            <p>名称：{{ dialogForm.enterpriseName }}</p>
            <p>手机号：{{ dialogForm.phone }}</p>
            <p>
              类型：{{
                dialogForm.worksType == "1"
                  ? "图片"
                  : dialogForm.worksType == "2"
                  ? "音频"
                  : "视频"
              }}
            </p>
            <p>状态：{{ getStatusText(dialogForm.status) }}</p>
            <p>申请时间：{{ dialogForm.createTime }}</p>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmOperation">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PageTitle from "@/components/pageTitle.vue";
import CusPagination from "@/components/cusPagination.vue";
import {
  getSignContractList,
  getSignContract,
  updateSignContract,
  downloadSignContract,
} from "@/api/consulting";

export default {
  components: {
    PageTitle,
    CusPagination,
  },
  data() {
    return {
      loading: true,
      filter: {
        enterpriseName: "",
        phone: "",
        identityType: "",
        status: "",
      },
      labelText: "",
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      dialogTitle: "",
      dialogForm: {
        id: "",
        enterpriseName: "",
        phone: "",
        worksType: "",
        status: "",
        createTime: "",
        reason: "",
      },
      operationType: "", // 'audit', 'disable', 'enable', 'detail'
      currentRow: null,
    };
  },
  computed: {
    rules() {
      return {
        reason: [
          {
            required: true,
            message: this.labelText,
            trigger: "blur",
          },
        ],
      };
    },
  },
  watch: {
    currentPage() {
      this.getList();
    },
  },
  methods: {
    getStatusText(status) {
      const map = {
        "1": "待审核",
        "2": "已通过",
        "3": "已拒绝",
        "4": "已禁用",
        "6": "已通过",
      };
      return map[status] || "未知";
    },
    getStatusTagType(status) {
      const map = {
        "1": "warning",
        "2": "success",
        "3": "danger",
        "4": "danger",
        "6": "success",
      };
      return map[status] || "";
    },
    async getList() {
      this.loading = true;
      const params = {
        pageSize: this.pageSize,
        pageNumber: this.currentPage,
        ...this.filter,
      };

      try {
        const { data } = await this.$ajax.get(getSignContractList, params);
        this.tableData = data?.data?.records || [];
        this.total = data?.data?.total || 0;
      } finally {
        this.loading = false;
      }
    },
    search() {
      this.currentPage = 1;
      this.getList();
    },
    reset() {
      this.filter = {
        enterpriseName: "",
        phone: "",
        worksType: "",
        status: "",
      };
      this.getList();
    },
    handleAudit(row) {
      this.$router.push({
        path: "/contractManagement/" + row.id,
        query: { type: "audit" },
      });
    },
    handleDetail(row) {
      this.$router.push({
        path: "/contractManagement/" + row.id,
        query: { type: "detail" },
      });
      // this.dialogTitle = "合同详情";
      // this.operationType = "detail";
      // this.currentRow = row;
      // this.dialogForm = { ...row };
      // this.dialogVisible = true;
    },
    handleDisable(row) {
      this.dialogTitle = "违规禁用";
      this.labelText = "请输入禁用原因";
      this.operationType = "disable";
      this.currentRow = row;
      this.dialogForm = {
        ...row,
        reason: "",
      };
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.dialogForm.clearValidate();
      });
    },
    handleEnable(row) {
      this.dialogTitle = "解除禁用";
      this.labelText = "请输入解禁原因";
      this.operationType = "enable";
      this.currentRow = row;
      this.dialogForm = {
        ...row,
        reason: "",
      };
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.dialogForm.clearValidate();
      });
    },
    handleUploadMaterial(row) {
      // 代传素材逻辑
      console.log("代传素材", row);
      this.$router.push({
        path: "/resourceUpload",
        query: {
          createBy: row.createBy,
          identityType: row.identityType,
          identityAuthType: row.identityAuthType,
        },
      });
    },
    handleDownloadContract(row) {
      // 下载合同逻辑
      console.log("下载合同", row);
      this.$ajax.get(downloadSignContract, { id: row.id }).then((res) => {
        if (res.data.code == 200) {
          const fileUrl = res.data.data.fileUrl;
          const a = document.createElement("a");
          a.href = fileUrl;
          a.download = "";
          a.click();
        } else {
          this.$message.error(res.data.msg);
          this.isLoading = false;
        }
      });
    },
    confirmOperation() {
      this.$refs.dialogForm.validate(async (valid) => {
        if (!valid) {
          return;
        }
        try {
          let newStatus = "";
          if (this.operationType === "disable") {
            newStatus = "4"; // 禁用
          } else if (this.operationType === "enable") {
            newStatus = "2"; // 解禁后恢复为已通过
          }

          this.$ajax
            .post(updateSignContract, {
              id: this.currentRow.id,
              status: +newStatus,
              cause: this.dialogForm.reason,
            })
            .then((res) => {
              if (res.data.code == 200) {
                this.$message.success("操作成功");
                this.getList();
                this.dialogVisible = false;
              }
            });
        } catch (error) {
          this.$message.error("操作失败");
        }
      });
    },
  },
  mounted() {
    if (this.$route.query.status) {
      this.filter.status = this.$route.query.status;
    }
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
.contract-management {
  .box-card {
    margin-bottom: 20px;
  }

  &__filter-header {
    display: flex;
    align-items: center;
  }

  &__body {
    .el-button {
      color: #005bff;
    }

    .el-table {
      border: 1px solid #ebeef5;
      border-bottom: none;
      margin-bottom: 20px;
    }
  }
}
</style>
